export const NOTE_SIZE = 32;

// TODO: move other hard coded constants here
